// import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import { lazy, Suspense } from "react";
import classes from "./App.module.css";
import { Routes, Route } from "react-router-dom";
import NavBar from "./components/layouts/navigation/NavBar";
import Title from "./components/Title";
import SocialMedia from "./components/layouts/navigation/SocialMedia";
import banner from "./assets/Bannerjan23.jpg";
import React, { useState, useRef } from "react";
// import About from "./views/About";
// import Projects from "./views/Projects";
// import Skills from "./views/Skills";
// import Contact from "./views/Contact";
// import MovieFilter from "./components/projects/MovieFilter";
// import NotFound from "./views/NotFound";
// import SkillWrapper from "./components/wrappers/SkillWrapper";
// import Music from "./components/skills/Music";
// import Videos from "./components/skills/Videos";
// import Press from "./components/skills/Press";
// import LoginPage from "./views/login/LoginPage";
import BouncingBall from "./components/spinners/BouncingBall";
const Home = lazy(() => import("./views/Home"));
const LoginPage = lazy(() => import("./views/login/LoginPage"));
const Press = lazy(() => import("./components/skills/Press"));
const Videos = lazy(() => import("./components/skills/Videos"));
const Music = lazy(() => import("./components/skills/Music"));
const SkillWrapper = lazy(() => import("./components/wrappers/SkillWrapper"));
const NotFound = lazy(() => import("./views/NotFound"));
const MovieFilter = lazy(() => import("./components/projects/MovieFilter"));
const Contact = lazy(() => import("./views/Contact"));
const Skills = lazy(() => import("./views/Skills"));
const Projects = lazy(() => import("./views/Projects"));
const About = lazy(() => import("./views/About"));

function App() {


  return (
    <>
      <header className={classes.header}>
       
        <div className={classes.title}>
          <Title />
        </div>
        <SocialMedia></SocialMedia>
        <NavBar />
      </header>
      <Suspense
        fallback={
          <div className={classes.loading}>
            {/* <h1>Loading...</h1> */}
            <BouncingBall></BouncingBall>
          </div>
        }
      >
        <main>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/:id" element={<About />} />
            <Route path="/skills" element={<SkillWrapper />}>
              <Route index element={<Skills />} />
              <Route path=":id" element={<Skills />} />
              <Route path="music" element={<Music />} />
              <Route path="videos" element={<Videos />} />
              <Route path="press" element={<Press />} />
            </Route>
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/projects">
              <Route index element={<Projects />} />
              <Route path="movies" element={<MovieFilter />} />
            </Route>
          </Routes>
        </main>
      </Suspense>
      <footer className={classes.footer}>
        <p>© 2023 Oliver Green - All rights reserved</p>
      </footer>
    </>

    // This is SWITCH for the routes.
    // <Router>
    //   <div>
    //     <nav>
    //       <ul>
    //         <li>
    //           <Link to="/">Home</Link>
    //         </li>
    //         <li>
    //           <Link to="/about">About</Link>
    //         </li>
    //         <li>
    //           <Link to="/projects">Projects</Link>
    //         </li>
    //       </ul>
    //     </nav>
    //     <Switch>
    //       <Route path="/about">
    //         <About />
    //       </Route>
    //       <Route path="/projects">
    //         <Projects />
    //       </Route>
    //       <Route path="/">
    //         <Home />
    //       </Route>
    //     </Switch>
    //   </div>
    // </Router>
  );
}

export default App;
